import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "src/app/shared/http.service";
import { APIEndpoints } from "src/config/apiEndpoint.config";
import { BulkConfigurationDto } from "../models/BulkConfigurationDto";
import { BulkConfigurationSettingDto } from "../models/BulkConfigurationSettingDto";

@Injectable()
export class BulkConfigurationService {
  constructor(private readonly httpService: HttpService) {}

  getBulkConfigurationSettings(): Observable<BulkConfigurationSettingDto[]> {
    return this.httpService.get(APIEndpoints.getBulkConfigurationSettings);
  }

  getBulkConfigurationsForCurrentUser(): Observable<
    BulkConfigurationSettingDto[]
  > {
    return this.httpService.get(
      APIEndpoints.getBulkConfigurationSettingsForCurrentUser
    );
  }

  changeBulkConfigurationSetting(data: BulkConfigurationSettingDto) {
    return this.httpService.post(
      APIEndpoints.changeBulkConfigurationSetting,
      data,
      false
    );
  }
}
